import React, { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, BoxProps as GrommetBoxProps, CardHeader as GrommetCardHeader } from 'grommet';
import { Box, Text } from '/src/components';

export const CardHeader: React.FC<CardHeaderProps> = ({ children, ...props }) => {
  const { title, icon, button, buttonNavigatePath, buttonTooltip, dataTour, ...boxProps } = props;

  const navigate = useNavigate();

  return (
    <GrommetCardHeader {...boxProps}>
      {icon && (
        <Box height="xxlarge" justify="center">
          {icon}
        </Box>
      )}
      {title && (
        <Box height="xxlarge" justify="center">
          <Text size="xlarge">{title}</Text>
        </Box>
      )}
      {button && (
        <Button
          pad="xsmall"
          icon={button}
          onClick={() => buttonNavigatePath && navigate(buttonNavigatePath)}
          tip={buttonTooltip}
          data-tour={dataTour}
        />
      )}
      {children && title && icon && <Box flex="grow" />}
      {children}
    </GrommetCardHeader>
  );
};

export type CardHeaderProps = PropsWithChildren &
  GrommetBoxProps & {
    button?: React.ReactElement;
    buttonNavigatePath?: string;
    buttonTooltip?: string;
    dataTour?: string;
    title?: string;
    icon?: React.ReactNode;
    style?: React.CSSProperties;
  };
